import React from 'react';
import HomeBanner from '../components/HomeBanner';
import PageLayout from '../components/PageLayout';
import SEO from '../components/SEO';

const HomePage = () => {
  return (
    <PageLayout>
      <SEO 
        title="TheMadZone - Premium Streetwear Fashion"
        description="Discover premium streetwear fashion at TheMadZone. Shop the latest urban clothing, streetwear essentials, and exclusive collections. Free shipping on orders over £100."
        keywords="streetwear, fashion, urban clothing, TheMadZone, street fashion, premium clothing"
      />
      <HomeBanner />
    </PageLayout>
  );
};

export default HomePage;
